export enum InvoiceStatus {
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PAID = 'PAID',
  NOT_YET_SUBMITTED = 'NOT YET SUBMITTED'
}
